// extracted by mini-css-extract-plugin
export default {"container":"Card_container__mX8E8","body":"Card_body__OAjZf","readMore":"Card_readMore__pyRV0","trash":"Card_trash__XxY+N"};